import { GridCellProps } from '@progress/kendo-react-grid';

type Props = {
  classname?: string;
  e: GridCellProps;
  onRowClick?: () => void;
};

const SIFCell = ({ classname, e, onRowClick }: Props) => {
  const data = e?.dataItem?.sif;
  return (
    <td className={classname ?? ''}>
      <div>{data ?? ''}</div>
    </td>
  );
};

export default SIFCell;
